/*=========================================================================================
  File Name: moduleMapState.js
  Description: Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	filter_exact_resource: false,
	filter_exact_break: false,
	filter_exact_company: false,
	filter_exact_vehicle: false,
	filter_exact_optimization: false,
	filter_exact_visit_point: false,
	filter_exact_capacity: false,
	filter_exact_skill: false,
	filter_exact_timewindow: false,
	filter_exact_optimization_group: false,
	filter_exact_frequency: false,
};
